import { getCategoryHref } from '../../utils/common/category';
import {
  PROMPT_GENERATOR_CATEGORY,
  TEXT_PROMPT_GENERATOR_CATEGORY,
  IMAGE_PROMPT_GENERATOR_CATEGORY,
  VIDEO_PROMPT_GENERATOR_CATEGORY,
  CODE_PROMPT_GENERATOR_CATEGORY,
} from '../../constants';

const chipValues = [
  {
    title: 'All',
    value: getCategoryHref(PROMPT_GENERATOR_CATEGORY),
  },
  {
    title: 'Text',
    value: getCategoryHref(TEXT_PROMPT_GENERATOR_CATEGORY),
  },
  {
    title: 'Image',
    value: getCategoryHref(IMAGE_PROMPT_GENERATOR_CATEGORY),
  },
  {
    title: 'Video',
    value: getCategoryHref(VIDEO_PROMPT_GENERATOR_CATEGORY),
  },
  {
    title: 'Code',
    value: getCategoryHref(CODE_PROMPT_GENERATOR_CATEGORY),
  },
];

export { chipValues };
